var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.791 11L7.62102 11L10.501 8.12003C10.891 7.73003 10.891 7.09003 10.501 6.70003C10.111 6.31003 9.48102 6.31003 9.09102 6.70003L4.50102 11.29C4.11101 11.68 4.11101 12.31 4.50102 12.7L9.08102 17.3C9.47102 17.69 10.101 17.69 10.491 17.3C10.881 16.91 10.881 16.28 10.491 15.89L7.62102 13L18.791 13C19.341 13 19.791 12.55 19.791 12C19.791 11.45 19.341 11 18.791 11Z",
    fill: "#0061AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.ff7be68d7c09777c14f6d90641d8ee0e.svg";
export { ForwardRef as ReactComponent };